import {OPEN_DEMO_IMAGE, CLOSE_DEMO_IMAGE} from '../actions/DemoActions';
import {selectedImagesReducer} from './selectedImages';
import {IMAGE_VIEWER_TOGGLE_ORIGINAL} from '../actions/PresetActions';

const initState = {
    id: null,
    isOriginalActive: false,
    selectedImages: [],
};

export const isDemoAction = (action) => {
    return action.type === OPEN_DEMO_IMAGE || action.demo;
};

export const demo = (state = initState, action) => {
    if (!isDemoAction(action)) {
        return state;
    }
    let newState = state;
    const oldSelectedImages = state.selectedImages || [];
    const selectedImages = selectedImagesReducer(oldSelectedImages, action);
    if (selectedImages !== oldSelectedImages) {
        newState = {...newState, selectedImages};
    }

    switch (action.type) {
        case OPEN_DEMO_IMAGE: {
            newState = {...newState, id: action.id};
            break;
        }
        case CLOSE_DEMO_IMAGE: {
            newState = {...newState, id: null};
            break;
        }
        case IMAGE_VIEWER_TOGGLE_ORIGINAL: {
            newState = {...newState, isOriginalActive: !state.isOriginalActive};
            break;
        }
        default:
            break;
    }

    return newState;
};



// WEBPACK FOOTER //
// ./src/reducers/demo.js